import { render, staticRenderFns } from "./StoryView.vue?vue&type=template&id=606b2908&scoped=true&"
import script from "./StoryView.vue?vue&type=script&lang=js&"
export * from "./StoryView.vue?vue&type=script&lang=js&"
import style0 from "./StoryView.vue?vue&type=style&index=0&id=606b2908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b2908",
  null
  
)

export default component.exports